import type { ISchema } from '../../@types'
import { IdentsOverrideId } from '@/helpers/identsOverrideIds'

// +10% premium intro products for female (used when High CR + High WTP)
import simple_premium_1w_5_71_4w_44_usd from '@/data/products/subscription/prd_oDYSyknItqiS'
import simple_premium_1w_4_57_4w_44_usd from '@/data/products/subscription/prd_hadaMkPe61BE'
import simple_premium_4w_10_99_4w_44_usd from '@/data/products/subscription/prd_WOGXapZkx96W'
import simple_premium_4w_8_79_4w_44_usd from '@/data/products/subscription/prd_AvZRhVsu6tNH'
import simple_premium_12w_21_99_12w_79_usd from '@/data/products/subscription/prd_ph4BSRgSCEuQ'
import simple_premium_12w_17_59_12w_79_usd from '@/data/products/subscription/prd_8HzNDRtZ7y5w'

// Female base (f.ts) has: original=null, discounted=base, fallback=fallback + ML_PRICE_DISCOUNT override.
// This transformer adds ML_PRICE_PREMIUM (+10% intro) on top, preserving the rolled-out discount.
export default (schema: ISchema): ISchema => {
	const products = schema.config?.products
	if (!products) return schema

	const premiumOverrides = [
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			discounted: simple_premium_1w_5_71_4w_44_usd.ident,
			fallback: simple_premium_1w_4_57_4w_44_usd.ident,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			discounted: simple_premium_4w_10_99_4w_44_usd.ident,
			fallback: simple_premium_4w_8_79_4w_44_usd.ident,
		},
		{
			id: IdentsOverrideId.ML_PRICE_PREMIUM,
			discounted: simple_premium_12w_21_99_12w_79_usd.ident,
			fallback: simple_premium_12w_17_59_12w_79_usd.ident,
		},
	]

	const updatedProducts = products.map((product, index) => ({
		...product,
		identsOverride: [...(product.identsOverride || []), premiumOverrides[index]],
	}))

	return { ...schema, config: { ...schema.config, products: updatedProducts } }
}
